import Amplify, { Auth, Storage } from "aws-amplify";
import moment from "moment";
import { createRef } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Joi from "joi-browser";

//  Images
import emptyIcon from "include/images/nrf.svg";
import plusIcon from "include/images/plus.svg";
import filterIcon from "include/images/filter-icon.svg";
import closeIcon from "include/images/close-icon.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { addRewardsCsv, getTelegram, loadRewardsCsv } from "store/telegram";
import CsvListingsFlyer from "../flyers/csvListingsFlyer";
import { isEmpty, pickBy, startCase } from "lodash";
import NextButton from "common/form/submitButton";
import SortIcon from "common/sortIcon";
import SelectSearch from "common/form/selectSearch";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: "us-east-1",
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET,
    region: "us-east-1",
  },
});
Auth.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: "us-east-1", // REQUIRED - Amazon Cognito Region
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET, //REQUIRED -  Amazon S3 bucket
    region: "us-east-1",
  },
});
class RewardsCsvList extends Form {
  ref = createRef(null);
  initialState = {
    loading: false,
    loadingFilters: false,
    data: {
      name: "",
      description: "",
      type: null,
      rarity: null,
      value: "",
      element: null,
      status: "",
    },
    appliedFilters: {},
    errors: {},
    sorting: { sort: "rewardId", order: "asc" },
    showFilters: false,
    page: 1,
    showCsvModal: false,
  };
  state = { ...structuredClone(this.initialState) };

  componentDidMount = () => {
    this.setState({ loading: true });
    this.searchFilters();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.getTelegram.rewardsCsvLoading &&
      this.props.getTelegram.rewardsCsvLoading !== prevProps.getTelegram.rewardsCsvLoading
    )
      this.ref.current.complete();

    if (
      this.props.getTelegram.rewardsCsvLoading &&
      this.props.getTelegram.rewardsCsvLoading !== prevProps.getTelegram.rewardsCsvLoading
    )
      this.ref.current.continuousStart();
  };
  searchFilters = () => {
    const data = { ...this.state.data };
    const sorting = { ...this.state.sorting };
    const payLoad = {
      ...data,
      type: data?.type?.value,
      rarity: data?.rarity?.value,
      element: data?.element?.value,
      sort: sorting?.sort,
      order: sorting?.order,
    };
    const params = pickBy(payLoad, function (value, key) {
      return value !== "";
    });

    params.page = this.state.page;
    this.setState({ loadingFilters: true });

    this.props.loadRewardsCsv(params, (res) => {
      if (res?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (data[key]) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({
          appliedFilters,
        });
      } else {
        toast(<AlertError message={res?.data?.message} />, {
          containerId: 1,
        });
      }
      this.setState({ loading: false, loadingFilters: false });
    });
  };
  handleCsvUpload = (e) => {
    this.ref.current.continuousStart();
    const fType = e.target.files[0].type;
    const fName = e.target.files[0].name;
    const ext = e.target.files[0].name.split(".").pop();
    if (!["text/csv"].includes(fType)) {
      toast(
        <AlertError message="File is not of correct format and hence cannot be uploaded. Valid format is csv only" />,
        {
          containerId: 1,
        },
      );
      this.ref.current.complete();
      e.target.value = null;
      return;
    } else {
      const fileName = uuidv4() + "." + ext;
      Storage.put("telegramBattleGame/csv/reward/" + fileName, e.target.files[0], {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      }).then((result) => {
        const data = { fileName: fName, filePath: "public/" + result.key };
        this.props.addRewardsCsv(data, (response) => {
          this.ref.current.complete();

          e.target.value = null;
          if (response.status === 200) {
            this.setState({ page: 1 }, () => this.searchFilters());

            toast(<AlertSuccess message="Information Saved" />, {
              containerId: 1,
            });
          } else {
            toast(<AlertError message={response.data && response.data.message} />, {
              containerId: 1,
            });
          }
        });
      });
    }
  };
  toggleShowCsvModal = () => {
    this.setState({ showCsvModal: !this.state.showCsvModal });
  };
  typeOptions = ["Gear", "Free Spin", "USDT", "Point", "Ticket"];
  rarityOptions = ["Common", "Uncommon", "Rare", "Legendary"];

  schema = {
    name: Joi.string().allow(""),
    description: Joi.string().allow(""),
    type: Joi.object().allow(null),
    rarity: Joi.object().allow(null),
    value: Joi.number().min(0.1).allow(""),
    status: Joi.string().allow(""),
    element: Joi.object().allow(null),
  };
  resetFilters = (e) => {
    e.preventDefault();
    this.setState({ ...structuredClone(this.initialState), showFilters: true }, () => this.searchFilters());
  };
  sort = (e, type) => {
    if (e) e.preventDefault();
    const sorting = { ...this.state.sorting };
    sorting.order = sorting?.sort === type && sorting.order === "desc" ? "asc" : "desc";
    sorting.sort = type;

    this.setState({ sorting, page: 1 }, () => {
      this.searchFilters();
    });
  };
  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];
    this.setState({ data, errors });
  };
  elementOptions = ["Water", "Fire", "Earth", "Air", "Neutral"];

  render() {
    const { rewardsCsv, rewardsCsvTotalCount } = this.props.getTelegram;

    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-battleGame-rewards" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Battle Game Rewards {rewardsCsvTotalCount > 0 && `(${rewardsCsvTotalCount})`}</h1>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                <div className="fmb-box">
                  <a
                    className="colored-link orange-text"
                    href={process.env.REACT_APP_CDN + "telegramBattleGame/sampleCsv/reward.csv"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download Sample CSV
                  </a>
                </div>

                <div className="fmb-box">
                  <Link className="colored-link orange-text" to="#" onClick={this.toggleShowCsvModal}>
                    CSV logs
                  </Link>
                </div>
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        showFilters: !this.state.showFilters,
                      });
                    }}
                  >
                    <img src={filterIcon} alt="filter" /> <span>Filters</span>
                  </a>
                </div>
                <div className="fmb-box">
                  <div className="kt-file-input">
                    <label htmlFor="formFile" className="btn btn-default btn-sm">
                      <img src={plusIcon} alt="" /> Import CSV
                    </label>
                    <input className="form-control" type="file" id="formFile" onChange={this.handleCsvUpload} />
                  </div>
                </div>
              </div>
            </div>
            {!this.state.loading && (
              <div className="fwc-wrapper">
                {this.state.showFilters && (
                  <div className="fwc-head ">
                    <div className="fwc-inner">
                      <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("name", "Name")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("description", "Description")}</div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            <label className="form-label">Type</label>
                            <SelectSearch
                              name="type"
                              options={this.typeOptions?.map((value) => ({ name: value, value }))}
                              label=""
                              value={this.state.data?.type}
                              error={this.state.errors?.type}
                              onChange={this.onChange}
                            />
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            {" "}
                            <label className="form-label">Rarity</label>
                            <SelectSearch
                              name="rarity"
                              options={this.rarityOptions?.map((value) => ({ name: value, value }))}
                              label=""
                              value={this.state.data?.rarity}
                              error={this.state.errors?.rarity}
                              onChange={this.onChange}
                            />
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">
                            <label className="form-label">Element</label>
                            <SelectSearch
                              name="element"
                              options={this.elementOptions?.map((value) => ({ name: value, value }))}
                              label=""
                              value={this.state.data?.element}
                              error={this.state.errors?.element}
                              onChange={this.onChange}
                            />
                          </div>
                        </li>
                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("value", "Value", "", "number")}</div>
                        </li>

                        <li className="flex-fill">
                          <div className="fml-box">{this.renderInput("status", "Status")}</div>
                        </li>
                      </ul>
                      <div className="fwc-btn d-flex align-items-center justify-content-end">
                        <NextButton
                          handleSubmit={this.resetFilters}
                          classData="btn-text pointer"
                          label="Reset"
                          loading={this.state.loadingReset}
                        />
                        <NextButton
                          handleSubmit={() => {
                            this.setState(
                              {
                                page: 1,
                              },
                              () => this.searchFilters(),
                            );
                          }}
                          classData="btn btn-primary btn-sm"
                          label="Search"
                          loading={this.state.loadingFilters}
                        />
                      </div>
                    </div>{" "}
                    {!isEmpty(this.state.appliedFilters) && (
                      <div className="filter-tag-container d-flex align-items-center ">
                        <div className="fwc-left">
                          <div className="filter-tag-list">
                            <p>filter applied :</p>
                            {Object.keys(this.state.appliedFilters).map((key) => (
                              <div className="filter-tag-item">
                                <span className="camelCase">{startCase(key)}</span> :{" "}
                                {this.state.appliedFilters[key]?.value ?? this.state.appliedFilters[key]}
                                <a
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState(
                                      {
                                        data: { ...this.state.data, [key]: "" },
                                        page: 1,
                                      },
                                      this.searchFilters,
                                    );
                                  }}
                                >
                                  <img src={closeIcon} alt="" />
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="fwc-body">
                  <div className="table-responsive">
                    {rewardsCsv?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table sticky-header">
                        <thead>
                          <tr>
                            <th>
                              Reward ID
                              <SortIcon
                                sortIconType="rewardId"
                                handleSort={(e) => this.sort(e, "rewardId")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Name
                              <SortIcon
                                sortIconType="name"
                                handleSort={(e) => this.sort(e, "name")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Description
                              <SortIcon
                                sortIconType="description"
                                handleSort={(e) => this.sort(e, "description")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Type
                              <SortIcon
                                sortIconType="type"
                                handleSort={(e) => this.sort(e, "type")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Rarity
                              <SortIcon
                                sortIconType="rarity"
                                handleSort={(e) => this.sort(e, "rarity")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>

                            <th>
                              Element
                              <SortIcon
                                sortIconType="element"
                                handleSort={(e) => this.sort(e, "element")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Value
                              <SortIcon
                                sortIconType="value"
                                handleSort={(e) => this.sort(e, "value")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>

                            <th>Image Name</th>
                            <th>
                              Status
                              <SortIcon
                                sortIconType="status"
                                handleSort={(e) => this.sort(e, "status")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>
                              Date
                              <SortIcon
                                sortIconType="createdAt"
                                handleSort={(e) => this.sort(e, "createdAt")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {rewardsCsv?.map((reward, i) => (
                            <tr key={i} className={reward?.status === "Deleted" ? "deleted-col" : ""}>
                              <td className="ps-3">{reward?.rewardId}</td>
                              <td>{reward?.name}</td>
                              <td>{reward?.description}</td>
                              <td>{reward?.type}</td>
                              <td>{reward?.rarity}</td>
                              <td>{reward?.element}</td>
                              <td>{reward?.value}</td>
                              <td>
                                <div style={{ width: 60 }}>
                                  {reward?.imageName && (
                                    <img
                                      src={
                                        process.env.REACT_APP_CDN +
                                        "telegramBattleGame/image/reward/" +
                                        reward?.imageName
                                      }
                                      alt=""
                                    />
                                  )}
                                </div>
                              </td>
                              <td>{reward?.status}</td>
                              <td>{moment(reward?.createdAt).format("ll")}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                  {!this.state.loading && !(this.state.page === 1 && rewardsCsv?.length === 0) && (
                    <div className="page-pagination">
                      <ul className="pagination  justify-content-end">
                        <li className="page-item">
                          <a
                            class={`page-link ${this.state.page === 1 && "disabled"}`}
                            href="#!"
                            aria-label="Previous"
                            onClick={(e) => {
                              e.preventDefault();
                              if (this.state.page > 1) {
                                this.setState({ page: this.state.page - 1 }, () => this.searchFilters());
                              }
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7 13L1 7L7 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                        <li className="page-item active">
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {this.state.page}
                          </a>
                        </li>
                        {rewardsCsv?.length >= 100 && (
                          <li className="page-item">
                            <a
                              className="page-link"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                              }}
                            >
                              {this.state.page + 1}
                            </a>
                          </li>
                        )}
                        <li className="page-item">
                          <a
                            class={`page-link ${rewardsCsv?.length < 100 && "disabled"}`}
                            href="#!"
                            aria-label="Next"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1 13L7 7L1 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <CsvListingsFlyer type={"reward"} showModal={this.state.showCsvModal} toggleModal={this.toggleShowCsvModal} />
        {this.state.showCsvModal && <div className="modal-backdrop show fade" onClick={this.toggleShowCsvModal}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadRewardsCsv: (params, callback) => dispatch(loadRewardsCsv(params, callback)),
  addRewardsCsv: (data, callback) => dispatch(addRewardsCsv(data, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RewardsCsvList));
